import React from 'react';
import './WhatsAppButton.css';
import { schoolInfo } from '../data/schoolData';

export default function WhatsAppButton() {
  const phone = schoolInfo.whatsapp;
  if (!phone) return null;
  const message = encodeURIComponent('Hello! I would like to inquire about admissions at St. Xavier\'s School.');
  const href = `https://wa.me/91${phone}?text=${message}`;

  return (
    <a
      className="whatsapp-float"
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat with us on WhatsApp"
    >
      <span>💬</span>
      <div>
        <strong>WhatsApp</strong>
        <small>Chat now</small>
      </div>
    </a>
  );
}
